import * as actions from './expandable-group.actions';
import { createReducer, on } from '@ngrx/store';

const initial: GroupExpandableData = {
  group: [],
};

const _groupExpandableReducer = createReducer(
  initial,
  on(actions.heightExpanded, (state, { nameGroup, height }) => {
    const stateTemp = {
      ...state,
    };
    if (stateTemp.group[nameGroup] !== undefined) {
      if (stateTemp.group[nameGroup].height < height) {
        stateTemp.group[nameGroup].height = height;
      }
    } else {
      stateTemp.group[nameGroup] = {
        height: height,
        expanded: false,
      };
    }

    return stateTemp;
  }),
  on(actions.valueExpanded, (state, { nameGroup, value }) => {
    const stateTemp = {
      ...state,
    };

    if (stateTemp.group[nameGroup] !== undefined) {
      if (stateTemp.group[nameGroup].expanded !== value) {
        stateTemp.group[nameGroup].expanded = value;
      }
    }
    return stateTemp;
  }),
);

export function groupExpandableReducer(state, action) {
  return _groupExpandableReducer(state, action);
}

interface ExpandableData {
  height: number;
  expanded: boolean;
}

export interface GroupExpandableData {
  group: ExpandableData[];
}
